import React, { ReactNode } from 'react';
import styles from './Desktop.module.scss';

export const Desktop = ({ children }: Props) => (
    <div className={styles.screen}>
        {children}
    </div>
);

type Props = { children: ReactNode };